import { useI18n } from '@affine/i18n';
import { ArrowRightBigIcon } from '@blocksuite/icons/rc';
import type { FC } from 'react';

import * as styles from './fanout-example.css';

/**
 * What splitting a list does, shown on one case: a response with a list of
 * three entries, and the three rows it becomes. The caption says the same in
 * words, so the picture itself stays out of the accessibility tree.
 */
export const FanoutExample: FC = () => {
  const t = useI18n();
  const entries = [
    t['com.streamlain.automation.sidebar.fanout.example.entry-1'](),
    t['com.streamlain.automation.sidebar.fanout.example.entry-2'](),
    t['com.streamlain.automation.sidebar.fanout.example.entry-3'](),
  ];

  return (
    <figure className={styles.figure} data-testid="fanout-example">
      <div className={styles.flow} aria-hidden="true">
        <div className={styles.side}>
          <span className={styles.sideLabel}>
            {t['com.streamlain.automation.sidebar.fanout.example.response']()}
          </span>
          <div className={styles.list}>
            <span className={styles.listName}>
              {t['com.streamlain.automation.sidebar.fanout.example.list']()}
            </span>
            {entries.map(entry => (
              <span key={entry} className={styles.entry}>
                {entry}
              </span>
            ))}
          </div>
        </div>
        <ArrowRightBigIcon className={styles.arrow} />
        <div className={styles.side}>
          <span className={styles.sideLabel}>
            {t['com.streamlain.automation.sidebar.fanout.example.table']()}
          </span>
          <div className={styles.rows}>
            {entries.map(entry => (
              <span key={entry} className={styles.row}>
                {entry}
              </span>
            ))}
          </div>
        </div>
      </div>
      <figcaption className={styles.caption}>
        {t['com.streamlain.automation.sidebar.fanout.example.caption']()}
      </figcaption>
    </figure>
  );
};
